<template>
  <div class="records-page">
    <skill-header title="组题记录" @back="$router.back()" />
    <main class="records-list">
      <div v-for="item in records" :key="item.studyPaperId">
        <button type="button" class="record-row" @click="openRecord(item)">
          <span class="record-main">
            <b>{{ item.title }}</b>
            <small>{{ item.createTime || item.updateTime || "" }}</small>
          </span>
          <span class="record-count"><b>{{ item.answerNum || 0 }}</b>/{{ item.questionNum || 0 }}</span>
          <span class="record-arrow" />
        </button>
      </div>
      <div v-if="!loading && !records.length" class="empty-state"><span>暂无数据</span></div>
    </main>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { studyPaperPage } from '@/api/subject/index.js'
import SkillHeader from './SkillHeader.vue'
import { readSkillCenterGroupRecords } from './shared'

export default {
  name: 'SkillCenterQuestionRecords',
  components: { SkillHeader },
  data() {
    return {
      loading: true,
      records: []
    }
  },
  created() {
    if (String(this.$route.query.preview) === '1') {
      this.records = [1, 2, 3].map((index) => ({
        studyPaperId: String(index),
        title: '第一章 绪论组题版',
        createTime: '2027.07.28 16:30',
        answerNum: 50,
        questionNum: 82
      }))
      this.loading = false
      return
    }
    this.loadRecords()
  },
  methods: {
    async loadRecords() {
      this.loading = true
      try {
        this.records = readSkillCenterGroupRecords()
        if (!this.records.length) {
          const res = await studyPaperPage({
            pageNum: 1,
            pageSize: 1000,
            studyBankId: this.$route.query.studyBankId || '',
            majorType: this.$route.query.majorType || ''
          })
          this.records = (res && res.data && res.data.rows) || []
        }
      } catch (error) {
        this.records = []
        Toast(error && error.msg ? error.msg : '组题记录加载失败')
      } finally {
        this.loading = false
      }
    },
    openRecord(item) {
      const localRecord = Array.isArray(item.categoryIds) && item.categoryIds.length
      this.$router.push({
        path: '/skillCenter/subjectHomeWork',
        query: {
          categoryId: localRecord ? item.categoryId : undefined,
          categoryIds: localRecord
            ? JSON.stringify(item.categoryIds)
            : undefined,
          studyPaperId: localRecord ? undefined : item.studyPaperId,
          source: localRecord ? 'group' : 'testCreation',
          majorType: item.majorType || this.$route.query.majorType,
          categoryOrganId: item.categoryOrganId || this.$route.query.categoryOrganId,
          organCategoryId: item.organCategoryId || this.$route.query.organCategoryId,
          practiceMode: item.mode || 'practice',
          questionLimit: localRecord ? item.count || item.questionNum : undefined,
          questionTypes: localRecord ? JSON.stringify(item.questionTypes || []) : undefined,
          groupCategories: localRecord ? JSON.stringify(item.categories || []) : undefined,
          groupRecordId: localRecord ? item.id || item.studyPaperId : undefined,
          groupNew: 0,
          label: item.title,
          skillCenter: 1,
          from: '/skillCenter/group/records'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.records-page {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background-color: #ffffff;
  background-image: url("~@/assets/images/skillCenterQuestion/header-background.png");
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 100% auto;
  color: #111111;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
  box-sizing: border-box;
}

.records-list {
  width: 100%;
  padding: 15px 19px;
  overflow-x: hidden;
  box-sizing: border-box;
}

.record-row {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 71px;
  padding: 9px 4px 9px 0;
  border: 0;
  border-bottom: 1px solid #eeeeee;
  background: transparent;
  text-align: left;
}

.record-main {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
}

.record-main b {
  overflow: hidden;
  font-size: 16px;
  font-weight: 600;
  line-height: 25px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.record-main small {
  margin-top: 5px;
  color: #9095a5;
  font-size: 14px;
}

.record-count {
  margin-left: 8px;
  color: #9095a5;
  font-size: 15px;
}

.record-count b {
  color: #168df5;
  font-weight: 400;
}

.record-arrow {
  width: 8px;
  height: 8px;
  margin-left: 8px;
  border-top: 1px solid #a4a8ad;
  border-right: 1px solid #a4a8ad;
  transform: rotate(45deg);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 118px);
  color: #a2a6af;
  font-size: 14px;
}

@media (min-width: 600px) {
  .records-page {
    width: 375px;
    margin: 0 auto;
  }
}
</style>
